const angular = require('angular');
var app = angular.module('learn-controllers');

/**
 * Saml Errors Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.controller('samlErrorsController', ['Application', '$translate', function (Application, $translate) {
  var self = this;
  self.routeParameters = Application.navigation.getRouteParameters();
  self.copyKeys = {
    0: 'saml.errors.invalid-request',
    1: 'saml.errors.company-invalid',
    2: 'saml.errors.user-suspended',
    3: 'saml.errors.user-limit-reached',
    4: 'saml.errors.required-from-ip',
    5: 'saml.errors.unkown-origin'
  };

  const ticketingBrand = Application.ticketingBrand;
  if (ticketingBrand.customSupport && ticketingBrand.location) {
    self.copyDef = {
      url: ticketingBrand.location,
      name: ticketingBrand.link
    };
  } else {
    self.copyDef = {
      url: 'mailto:' + Application.supportEmailAddress,
      name: Application.supportEmailName
    };
  }

  $translate([
    'saml.errors.invalid-request',
    'saml.errors.company-invalid',
    'saml.errors.user-suspended',
    'saml.errors.user-limit-reached',
    'saml.errors.required-from-ip',
    'saml.errors.unkown-origin'
  ]).then(function(data){
    self.code = self.routeParameters.code;
    console.log('code: ', self.code)
    self.errorKey = self.copyKeys[self.code] || self.copyKeys[5];
    console.log('errorKey: ', self.errorKey)
  });
}]);
